/**
 * builds the carrier options the commission statement report expects, dropping
 * the carriers that have no Callidus name and adding the catch-all "Other"
 * @param statementsCarriers - carriers from state.appointments.satementsCarriersArray
 */
export default function buildStatementCarrierOptions(statementsCarriers = []) {
  return statementsCarriers
    .filter(carrier => carrier.Callidus_Carrier_Names !== undefined)
    .map(carrier => ({
      type: carrier.type,
      name: carrier.name,
      id: carrier.AgencyBloc_CarrierID,
      Callidus_Carrier_Names: carrier.Callidus_Carrier_Names
    }))
    .concat([
      { type: 'Marketplace', name: 'Other', id: '', Callidus_Carrier_Names: 'Other' }
    ])
    .filter(carrier => carrier.type);
}
